import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-b-small', 'LetterBSmall', [["path",{"d":"M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8","key":"svg-0"}]]);